import { EventType } from "@/types";

import { axios } from "../axios.instance";

export type CreateAffairRequest = Required<
  Pick<EventType, "title" | "description" | "photos" | "location" | "startDate" | "endDate" | "capacity">
>;

export type CreateAffairResponse = EventType;

export const createAffair = async (body: CreateAffairRequest): Promise<CreateAffairResponse> => {
  const { data } = await axios.post(`/events/affairs/create`, body);

  return data;
};
